import { Breadcrumb } from './breadcrumb/breadcrumb.component'
import { AccountUsageComponent } from './../reports/components/accountUsage/accountUsage.component'
import { Inject, Input, OnDestroy, OnInit } from '@angular/core'
import { Component } from '@angular/core'
import { AuthService } from '../core/services/auth.service'
import { ActivatedRoute, Router } from '@angular/router'
import { __Permissions } from '../core/permissionEnum/permissions'
import { LighthouseService } from '../shared/services/lighthouse.service'
import { MenuItem } from 'primeng/api'
import { BehaviorSubject, map, Subject } from 'rxjs'
import { data } from 'jquery'
import { BreadCrumbService } from '../core/services/breadcrumb.service'
import { DocumentAIService } from '../shared/services/documentAI.service'
import { HumanTask } from '../document/interfaces/HumanTask'
import { AppMenuSyncService } from '../shared/services/app-menu-sync.service'
import { UnsavedChangesGuardService } from '../shared/services/unsaved-changes-guard.service'

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styles: [`
        .submitButton {
    color: #fff;
    background-color: #7364db;
    padding: 9px;
    margin-right: 10px !important;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    margin-top: 15px;
    display: inline-block;
    border: none;
    cursor: pointer;
    margin-left: 0px;
}
    .save-icon::before {
    color: #fff;
}
        `],
})
export class AppMenuComponent implements OnInit, OnDestroy {
    allFunctionList: any[]
    caseRecordTypes: any[] = []
    documentRecord: any[] = []
    allFunctionListDeail: any[]
    model: any[] = []
    activeIndex: number | null = null;
    ContributorMenu: any[] = []
    DocumentsMenu: any[] = []
    AdminMenu: any[] = []
    DeveloperMenu: any[] = []
    AiAgentDashboardMenu: any[] = []
    PlinyMenu: any[] = []
    IsDashboardConfigured: boolean;
    hasContributorPermission: boolean = false
    selectedMenu: string = ''
    hasAdminPermission: boolean = false
    hasPlinyPermission: boolean = false
    showRefreshBtn: boolean = false;
    totalFunctions: any
    documentQuery: any
    DocumentsList: HumanTask[] = []
    documentTotalCount: number = 0
    showDocumentTaskList: boolean = false
    skipCount: any
    maxResultCount = 30
    DocumentID: any


    constructor(
        public authService: AuthService,
        private router: Router,
        public service: LighthouseService,
        private docAiservice: DocumentAIService,
        private appMenuSyncService: AppMenuSyncService,
        @Inject(BreadCrumbService) private breadcrumbService: BreadCrumbService,
        private unsavedChangesService: UnsavedChangesGuardService
    ) {

    }

    contributorPermissions = [
        __Permissions.document_create,
        __Permissions.documentEdit,
        __Permissions.document_delete,
        __Permissions.WorkItem,
        __Permissions.documentList,
        __Permissions.select_Case,
    ]
    documenttab = [__Permissions.select_Case]
    adminPermissions = [
        __Permissions.templateCreate,
        __Permissions.createPipeline,
        __Permissions.reports,
        // __Permissions.taskQueue,
        __Permissions.createTaskQueue,
        __Permissions.ManageMembers,
        __Permissions.users,
        __Permissions.events_create,
        __Permissions.CaseRecordTypesCreate,
        __Permissions.Configration,
        __Permissions.DocumentTags_Create,
        __Permissions.WebhookSubscription_Create,
        __Permissions.CaseTypeAssistants_Create,
        __Permissions.StarterKits
    ]
    developerPermissions = [__Permissions.functionCall]
    plinyPermissions = [
        __Permissions.Provider,
        __Permissions.Location,
        __Permissions.Patient,
        __Permissions.Payor,
        __Permissions.Lookups,
    ]
    AgentsDashboardPermissions: any = [];
    parseQueryParams(url: string): { [key: string]: any } {
        let queryString: any = url.split('?query=?')[1]
        // console.log(queryString)
        return queryString
    }

    ngOnDestroy(): void {
        this.DocumentsList = []
    }

    ngOnInit() {
        this.checkIfDashboardConigured();
        this.appMenuSyncService.getSyncUpdates().subscribe((data) => {
            if (data) {
                if (localStorage.getItem('filter') != null || undefined) {
                    let params: any = this.parseQueryParams(
                        localStorage.getItem('filter')
                    )
                    this.documentQuery = `?${params}`
                }
                this.showDocumentTaskList = data.showMenu
                this.SelectRole(data.name);

                // this.syncAppMenu(data) // Perform synchronization
            }
        })
        this.docAiservice.documentIdView.subscribe((document: any) => {
            this.DocumentID = document
        })
        this.docAiservice.selectedDocumentTaskStatus$.subscribe((res: any) => {
            if (res) {
                this.DocumentsMenu[0].items = this.DocumentsMenu[0].items.map((dataDoc: any) => {
                    if (dataDoc.id === res.id) {
                        const isActive = this.DocumentID === res.id ? 'active-route' : '';
                        const statusClass = res.status === 'Verified' ? 'GreenStat' : 'ErrorStat';
                        return {
                            ...dataDoc,
                            status: res.status, // Update status
                            class: `upload-doc doc-list uploadItemList ${statusClass}  ${isActive}`,
                        };
                    }
                    return dataDoc;
                });
            }

        });


        if (__Permissions.select_Case) {
            this.getCaseTypes()
        }

        this.checkForSideNavPermission()
        this.ContributorMenu = [
            {
                items: [
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.document_create,
                    //         false
                    //     ),
                    //     label: 'Upload Documents',
                    //     routerLink: ['/document/create'],
                    //     class: 'upload-doc',
                    //     data: { breadcrumb: 'Upload Documents' },
                    // },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.documentList,
                            false
                        ),
                        label: 'Sortis',
                        routerLink: ['/document/sortis'],
                        class: 'upload-doc process-list',
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.documentList,
                            false
                        ),
                        label: 'Documents',
                        routerLink: ['/document/list'],
                        class: 'upload-doc doc-list',
                        data: { breadcrumb: 'Documents' },
                    },
                    // Work item modules are hidden from the left menu for now.
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.WorkItem,
                    //         false
                    //     ),
                    //     label: 'Tasks',
                    //     routerLink: ['/documentAI/tasks'],
                    //     class: 'upload-doc tasks',
                    //     data: { breadcrumb: 'Tasks' },
                    // },
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.WorkItem,
                    //         false
                    //     ),
                    //     label: 'Approvals',
                    //     routerLink: ['/documentAI/approvals'],
                    //     class: 'upload-doc approvals',
                    //     data: { breadcrumb: 'Approvals' },
                    // },
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.WorkItem,
                    //         false
                    //     ),
                    //     label: 'Queries',
                    //     routerLink: ['/documentAI/queries'],
                    //     class: 'upload-doc queries',
                    //     data: { breadcrumb: 'Queries' },
                    // },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.batchCreate,
                            false
                        ),
                        label: 'Batches',
                        routerLink: ['/batch/list'],
                        class: 'upload-doc batches',
                        data: { breadcrumb: 'Batches' },
                    },                
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.select_Case,
                            false
                        ),
                        label: 'Case',
                        class: 'case-list',
                        items: [],
                        menuType: 'case-types',
                        // command: () =>  this.getCaseTypes(),
                    },
                ],
            },
        ]
        this.DocumentsMenu = [
            {
                items: [
                    {
                        visible: this.showDocumentTaskList,
                        label: 'Document List',
                        class: 'upload-doc doc-list',
                        // items: [],
                        menuType: 'case-types',
                        // command: () =>  this.getDocumentList(),
                    },
                ],
            },
        ]
        this.AdminMenu = [
            {
                icon: 'pi pi-user',
                label: 'Administration',
                data: { breadcrumb: 'Administration' },
                items: [
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.reports,
                            false
                        ),
                        label: 'Reports',
                        class: 'upload-doc reportIcon',
                        routerLink: ['/reports'],
                        data: { breadcrumb: 'Reports' },
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.templateCreate,
                            false
                        ),
                        label: 'Templates',
                        class: 'upload-doc templateIcon',
                        routerLink: ['/administration/template'],
                        data: { breadcrumb: 'Templates' },
                    },
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.documentScriberCreate,
                    //         false
                    //     ),
                    //     label: 'Document Scribe',
                    //     class: 'upload-doc documentScribe',
                    //     routerLink: ['administration/documentWriter'],
                    //     data: { breadcrumb: 'Document Scribe' }
                    // },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.users,
                            false
                        ),
                        label: 'Users',
                        class: 'upload-doc userIcon',
                        routerLink: ['/administration/user'],
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.createPipeline,
                            false
                        ),
                        label: 'Pipelines',
                        class: 'upload-doc pipelineIcon',
                        routerLink: ['/administration/pipelines'],
                        data: { breadcrumb: 'Pipelines' },
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.createTaskQueue,
                            false
                        ),
                        label: 'Task Queues',
                        class: 'upload-doc queIcon',
                        routerLink: ['/administration/taskQueue'],
                        data: { breadcrumb: 'Task Queues' },
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.CaseRecordTypesCreate,
                            false
                        ),
                        label: 'Case Types',
                        class: 'upload-doc caseRecordIcon',
                        routerLink: ['/administration/CaseType'],
                        data: { breadcrumb: 'AI Agents' },
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.batchCreate,
                            false
                        ),
                        label: 'Training',
                        routerLink: ['/batch/training'],
                        class: 'upload-doc batches',
                        data: { breadcrumb: 'Batches' },
                    },
                    // Knowra is hidden from the left menu for now.
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.knowraCreate,
                    //         false
                    //     ),
                    //     label: 'Knowra',
                    //     routerLink: ['/knowra/list'],
                    //     class: 'upload-doc knowraIcon',
                    //     data: { breadcrumb: 'Knowra' },
                    // },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.CaseTypeAssistants_Create,
                            false
                        ),
                        label: 'Assistant',
                        class: 'upload-doc caseAssistant',
                        routerLink: ['/administration/caseAssistant/list'],
                        data: { breadcrumb: 'Assistant' },
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.ManageMembers,
                            false
                        ),
                        label: 'Teams',
                        class: 'upload-doc teamsIcon',
                        routerLink: ['/administration/team'],
                        data: { breadcrumb: 'Teams' },
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.events_create,
                            false
                        ),
                        label: 'Events',
                        class: 'upload-doc eventIcon',
                        routerLink: ['/administration/event'],
                        data: { breadcrumb: 'Teams' },
                    },
                    // Intake Accounts is hidden from the left menu for now.
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.EmailAccount,
                    //         false
                    //     ),
                    //     label: 'Intake Accounts',
                    //     class: 'upload-doc emailAccountIcon',
                    //     routerLink: ['/administration/intake-account'],
                    //     data: { breadcrumb: 'Intake Accounts' },
                    // },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.Configration,
                            false
                        ),
                        label: 'Import / Export',
                        class: 'upload-doc configIcon',
                        routerLink: ['/administration/configuration'],
                        data: { breadcrumb: 'Import / Export' },
                    },
                    {
                        visible: this.authService.hasPermission(
                            __Permissions.DocumentTags_Create,
                            false
                        ),
                        label: 'Tags',
                        class: 'upload-doc tagIcon',
                        routerLink: ['/administration/tagsList'],
                        data: { breadcrumb: 'Tag' },
                    },
                    {
                        // icon: 'pi pi-cog',
                        visible: this.authService.hasPermission(
                            __Permissions.functionCall
                        ),
                        menuType: 'functions',
                        label: 'Automation',
                        class: 'automationIcon',
                        routerLink: ['/automation'],
                        data: { breadcrumb: 'Teams' },
                    },
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.StarterKits,
                    //         false
                    //     ),
                    //     label: 'Starter Kits',
                    //     class: 'upload-doc starterKit',
                    //     routerLink: ['/administration/starterKit'],
                    //     data: { breadcrumb: 'starter Kit' },
                    // },

                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.WebhookSubscription_Create , false
                    //     ),
                    //     label: 'Web Hooks',
                    //     class: 'upload-doc webhooksIcon',
                    //     routerLink: ['/administration/webHooks'],
                    //     data: { breadcrumb: 'webHooks' }
                    // },
                    // {
                    //     //TODO change to  account balance permissions
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.CaseRecords,
                    //         false
                    //     ),
                    //     label: 'Case Records',
                    //     class: 'upload-doc caseRecordIcon',
                    //     routerLink: ['/administration/casefields'],
                    // },
                    // {
                    //     //TODO change to  account balance permissions
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.caseRecordFieldsCustomizationses,
                    //         false
                    //     ),
                    //     label: 'Custom Case Records Fields',
                    //     class: 'upload-doc customFieldIcon',
                    //     routerLink: ['/administration/customcasefields'],
                    // },
                    // {

                    //     visible:this.authService.hasPermission(__Permissions.BalanceCredits,false),
                    //     label: 'Account Balance',
                    //     icon: 'pi pi-folder',
                    //     routerLink: ['/administration/balancecredits'],
                    // },
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.createCheckListTemplateItem,
                    //         false
                    //     ),
                    //     label: 'Checklist Template',
                    //     class: 'upload-doc checklistIcon',
                    //     routerLink: ['/administration/checklist'],
                    // },
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.createRoles,
                    //         false
                    //     ),
                    //     label: 'Roles',
                    //     class: 'upload-doc roleIcon',
                    //     routerLink: ['/administration/roles'],
                    // },
                    // {
                    //     visible: this.authService.hasPermission(
                    //         __Permissions.ChecklistTemplateItems,
                    //         false
                    //     ),
                    //     label: 'Audit Logs',
                    //     class: 'upload-doc checklistIcon',
                    //     routerLink: ['/administration/audit-logs'],
                    // },
                ],
            },
        ]
        this.getstarterKits();
        if (this.hasContributorPermission) {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'Contributor', route: '' },
            ])

            this.selectedMenu = 'contributor'
            this.model = this.ContributorMenu
            // this.getCaseTypes()
        } else if (this.showDocumentTaskList) {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'Documents', route: '' },
            ])

            this.selectedMenu = 'Documents'
            this.model = this.DocumentsMenu
            this.getDocumentList()
        } else if (this.hasAdminPermission) {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'Administration', route: '' },
            ])
            this.selectedMenu = 'admin'
            this.model = this.AdminMenu
        }

        this.selectedActivetab()
        // if (this.router.url.includes('/AIDashboard')) {
        //     this.SelectRole('AIDashboard')
        // }
    }

    // syncAppMenu(data: any) {
    //     // console.log('AppMenuComponent synchronized with:', data)
    //     // Logic to sync component (update menu, refresh, etc.)
    // }
    checkIfDashboardConigured() {
        this.docAiservice.IsDashboardConfigured().subscribe(
            (data: any) => {
                this.IsDashboardConfigured = data.result;
            }
        )
    }
    getCaseTypes() {
        let url = `?StatusFilter=Published&MaxResultCount=100`
        this.docAiservice.GetAllCaseRecordsType(url).subscribe((data: any) => {
            const lastMenu = this.ContributorMenu[0].items.length - 1
            this.ContributorMenu[0].items[lastMenu].items = []
            const caseRecordTypes = data.result.items?.map(
                (a: any) => a.caseRecordType
            )

            for (const caseType of caseRecordTypes) {
                this.ContributorMenu[0].items[lastMenu].items.push({
                    label: caseType.name,
                    menuType: 'case-types',
                    class: 'upload-doc caseRecordIcon',
                    command: () => this.gotoCaseType(caseType),
                })


            }
            this.showRefreshBtn = true;
            this.caseRecordTypes = caseRecordTypes
            this.ContributorMenu[0].items[lastMenu].visible = this.caseRecordTypes.length == 0 ? false : true
            this.model = this.ContributorMenu
        })
    }

    getstarterKits() {
        this.docAiservice.GetStarterKits().subscribe((data: any) => {
            if (data) {
                let items = data.result.items;
                if (items.length > 1) {
                    this.AdminMenu[0].items.push({
                        visible: this.authService.hasPermission(
                            __Permissions.StarterKits,
                            false
                        ),
                        label: 'Starter Kits',
                        class: 'upload-doc starterKit',
                        routerLink: ['/administration/starterKit'],
                        data: { breadcrumb: 'starter Kit' },
                    });
                }
            }

        })
    }
    getDocumentList() {
        this.docAiservice.GetAllHumanTAsk(this.documentQuery).subscribe(
            (data: any) => {

                // const newDocuments = data.tasks;
                this.documentTotalCount = data.totalCount
                this.DocumentsList = data.tasks
                this.getMaxResultCount(this.documentQuery)

                const lastMenu = this.DocumentsMenu[0].items.length - 1
                this.DocumentsMenu[0].items = []
                for (const doc of this.DocumentsList) {
                    const isActive = this.DocumentID === doc.id ? 'active-route' : '';
                    const statusClass = doc.status == 'Verified' ? 'GreenStat' : 'ErrorStat';
                    this.DocumentsMenu[0].items.push({
                        label: doc.name,
                        id: doc.id,
                        menuType: 'case-types',
                        class: `upload-doc doc-list uploadItemList ${statusClass} ${isActive}`,
                        command: () => this.gotoDocumentDetails(doc),
                    })
                }

                this.documentRecord = this.DocumentsList
                this.DocumentsMenu[0].items[lastMenu].visible =
                    this.documentRecord.length == 0 ? false : true
                this.model = this.DocumentsMenu
            },
            (error) => {
                console.error('Error fetching documents:', error)
            }
        )
    }

    getMaxResultCount(query: string): number {
        const match = query.match(/&MaxResultCount=(\d+)/)
        this.skipCount = query.match(/&SkipCount=(\d+)/)
        // console.log(this.skipCount)
        this.skipCount = parseInt(this.skipCount[1], 10)
        // console.log(this.skipCount, 'after')
        return match ? parseInt(match[1], 10) : 0 // If no match, default to 0
    }

    // Method to update SkipCount within the query string
    updateMaxResultCount(query: string, newMaxResultCount: number): string {
        // Use a regular expression to find and replace &SkipCount=<value>
        return query.replace(
            /(&MaxResultCount=)(\d+)/,
            `$1${newMaxResultCount}`
        )
    }


    loadMoreDocuments() {
        // Extract the current SkipCount from the query string
        let currentSkipCount = this.getMaxResultCount(this.documentQuery)

        // Check the current SkipCount and then increment by 10
        if (currentSkipCount !== null && !isNaN(currentSkipCount)) {
            const newMaxResultCount = currentSkipCount + 10 // Add 10 to the current SkipCount

            // Update the query with the new skip count
            this.documentQuery = this.updateMaxResultCount(
                this.documentQuery,
                newMaxResultCount
            )

            // Call your API with the updated query
            // console.log('Updated query:', this.documentQuery)

            // Fetch the next set of documents from the API and append to the existing ones
            this.getDocumentList()
        }
    }

    gotoCaseType(caseType: any) {
        this.docAiservice.filterCaseTypeSubject.next(caseType.id)
        this.docAiservice.CaseTypeName.next(caseType.name)
        this.router.navigate(['/case/caselist/', caseType.id])
    }

    async gotoDocumentDetails(doc: any) {
        // Check for unsaved changes before navigation
        const canProceed = await this.unsavedChangesService.navigateWithCheck(
            'navigateToDocument',
            () => {
                this.docAiservice.documentTaskListSubject.next(doc.id);
                this.router.navigate(['/document/processed/', doc.id], {
                    state: { documentNumber: 1 },
                });
                if (this.DocumentID !== '') {
                    this.DocumentID = '';
                    this.getDocumentList();
                }
            }
        );

        // If user cancelled, navigation won't proceed
        if (!canProceed) {
            return;
        }
    }

    proceedNavigate(doc: any) {
        this.docAiservice.documentTaskListSubject.next(doc.id);

        if (this.DocumentID !== '') {
            this.DocumentID = '';
            this.getDocumentList();
        }
    }

    setActiveIndex(index: number): void {
        this.activeIndex = index;
    }

    SelectRole(role: string) {
        this.model = []
        this.breadcrumbService.setBreadcrumbs([])
        if (role == 'contributor') {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'Contributor', route: '' },
            ])
            //   for testing more records
            this.getCaseTypes()
            this.model = this.ContributorMenu
            this.selectedMenu = 'contributor'
        } else if (role == 'Documents') {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'Documents', route: '' },
            ])
            //   for testing more records
            //   this.getCaseTypes()
            this.model = this.DocumentsMenu
            this.selectedMenu = 'Documents'
            this.getDocumentList()
        } else if (role == 'admin') {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'Administration', route: '' },
            ])
            this.selectedMenu = 'admin'
            this.model = this.AdminMenu;
        }
        else if (role == 'AIDashboard') {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'AI Agent', route: '' },
            ])
            this.selectedMenu = 'AIDashboard'
            // this.getCaseTypes();
            this.AiAgentDashboardMenu = [
                {
                    icon: 'pi pi-chart-line',
                    label: 'AI Agent',
                    data: { breadcrumb: 'AI Agent' },
                    items: []
                },
            ]

            this.docAiservice.GetCaseTypeAssistant('?OperatingModeFilter=Agent&StatusFilter=Published&Sorting=creationTime desc&MaxResultCount=100').subscribe(
                (data: any) => {
                    const caseAssistants = data.result.items?.map((a: any) => {
                        const eventObj = { ...a.caseTypeAssistant };
                        return eventObj;
                    });

                    this.appMenuSyncService.AIAGentList = caseAssistants.sort((a: any, b: any) => a.name.localeCompare(b.name));

                    if (this.appMenuSyncService.AIAGentList.length > 0) {
                        this.appMenuSyncService.AIAGentList.forEach((element: any) => {
                            let menuObj = {
                                visible: true,
                                label: `${element.name} (${element.caseType})`,
                                class: 'upload-doc reportIcon',
                                command: () => this.GoToAIAgentDashboard(element),
                            }
                            this.AiAgentDashboardMenu[0].items.push(menuObj)
                        });
                        this.GoToAIAgentDashboard(this.appMenuSyncService.AIAGentList[0])

                    } else {
                        let menuObj = {
                            visible: true,
                            label: 'No Agents Found',
                            class: 'upload-doc reportIcon',
                        }
                        this.AiAgentDashboardMenu[0].items.push(menuObj)
                    }
                }
            );
            this.model = this.AiAgentDashboardMenu;
        } else if (role == 'pliny') {
            this.breadcrumbService.setBreadcrumbs([
                { label: '', route: '' },
                { label: 'Pliny', route: '' },
            ])
            this.selectedMenu = 'pliny'
            this.PlinyMenu = [
                {
                    icon: 'fa fa-solid fa-user-tie',
                    label: 'Pliny',
                    data: { breadcrumb: 'Pliny' },
                    items: [
                        {
                            icon: 'fa fa-user-md',
                            label: 'Providers',
                            visible: this.authService.hasPermission(
                                __Permissions.Provider,
                                false
                            ),
                            items: [
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Provider,
                                        false
                                    ),
                                    label: 'List',
                                    icon: 'fa fa-list',
                                    routerLink: ['/pliny/providers'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Provider,
                                        false
                                    ),
                                    label: 'Provider Alerts',
                                    icon: 'fa fa-exclamation-circle',
                                    routerLink: ['/pliny/providers/alerts'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Provider,
                                        false
                                    ),
                                    label: 'Provider Leave',
                                    icon: 'fa fa-calendar-times',
                                    routerLink: ['/pliny/providers/leaves'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Provider,
                                        false
                                    ),
                                    label: 'Providers Location Availability',
                                    icon: 'fa fa-calendar-check',
                                    routerLink: ['/pliny/providers/location-availability'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Provider,
                                        false
                                    ),
                                    label: 'Extract By Url',
                                    icon: 'fa fa-link',
                                    routerLink: ['/pliny/providers/extract-by-url'],
                                }
                            ]
                        },
                        {
                            icon: 'fa fa-globe',
                            label: 'Locations',
                            visible: this.authService.hasPermission(
                                __Permissions.Location,
                                false
                            ),
                            items: [
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Location,
                                        false
                                    ),
                                    label: 'List',
                                    icon: 'fa fa-list',
                                    routerLink: ['/pliny/locations'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Location,
                                        false
                                    ),
                                    label: 'Location Closures',
                                    icon: 'fa fa-ban',
                                    routerLink: ['/pliny/locations/closures'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Location,
                                        false
                                    ),
                                    label: 'Location Holidays',
                                    icon: 'fa fa-calendar',
                                    routerLink: ['/pliny/locations/holidays'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Location,
                                        false
                                    ),
                                    label: 'Nearby Location',
                                    icon: 'fa fa-map-pin',
                                    routerLink: ['/pliny/locations/nearby'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Location,
                                        false
                                    ),
                                    label: 'Extract By Url',
                                    icon: 'fa fa-link',
                                    routerLink: ['/pliny/locations/extract-by-url'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Location,
                                        false
                                    ),
                                    label: 'Location Groups',
                                    icon: 'fa fa-users',
                                    routerLink: ['/pliny/location-groups'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Location,
                                        false
                                    ),
                                    label: 'Location Availabilities',
                                    icon: 'fa fa-calendar-check',
                                    routerLink: ['/pliny/location-availabilities'],
                                },
                            ]
                        },
                        {
                            visible: this.authService.hasPermission(
                                __Permissions.Location,
                                false
                            ),
                            label: 'Location To Group Mapping',
                            icon: 'fa fa-users',
                            routerLink: ['/pliny/location-group-members'],
                        },
                        {
                            visible: this.authService.hasPermission(
                                __Permissions.Lookups,
                                false
                            ),
                            icon: 'fa fa-clone',
                            label: 'All Lookups',
                            routerLink: ['/pliny/allLookups']
                        },
                        {
                            visible: true,
                            icon: 'fa fa-tasks',
                            label: 'Network Status',
                            routerLink: ['/pliny/network-status']
                        },
                        {
                            icon: 'fa fa-solid fa-hospital-user',
                            label: 'Patient',
                            visible: this.authService.hasPermission(
                                __Permissions.Patient,
                                false
                            ),
                            items: [
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Patient,
                                        false
                                    ),
                                    label: 'Patients',
                                    icon: 'fa fa-users',
                                    routerLink: ['/pliny/patient/patients'],
                                },
                                {
                                    visible: this.authService.hasPermission(
                                        __Permissions.Patient,
                                        false
                                    ),
                                    label: 'Eligibility',
                                    icon: 'fa-solid fa-gauge-simple',
                                    routerLink: ['/pliny/patient/eligibility-request'],
                                }
                            ]
                        },
                        {
                            visible: this.authService.hasPermission(
                                __Permissions.Payor,
                                false
                            ),
                            icon: 'fa fa-building',
                            label: 'Insurance Payors',
                            routerLink: ['/pliny/insurance-payors']
                        }
                    ]
                },
            ]
            this.model = this.PlinyMenu
            this.router.navigate(['/pliny'])
        }
    }
    // }
    GoToAIAgentDashboard(dashboard: any) {
        this.router.navigate([`/Agent/home`, dashboard.name]);
        this.docAiservice.setCaseData({ id: dashboard.id, caseTypeId: dashboard.caseTypeId });

    }
    checkForSideNavPermission() {
        // let contributorCount = 0
        this.contributorPermissions.forEach((element) => {
            if (this.authService.hasPermission(element, false)) {
                this.hasContributorPermission = true
            }
        })
        this.documenttab.forEach((element) => {
            if (this.authService.hasPermission(element, false)) {
                this.hasContributorPermission = true
            }
        })
        this.adminPermissions.forEach((element) => {
            if (this.authService.hasPermission(element, false)) {
                this.hasAdminPermission = true
            }
        })
        this.plinyPermissions.forEach((element) => {
            if (this.authService.hasPermission(element, false)) {
                this.hasPlinyPermission = true
            }
        })

        if (
            !this.hasAdminPermission &&
            !this.hasContributorPermission &&
            !this.hasPlinyPermission
        ) {
            this.router.navigate(['/no-access'])
        }
    }
    selectedActivetab() {
        this.ContributorMenu[0].items.forEach((menu: any) => {
            if (window.location.href.includes(menu.routerLink[0])) {
                this.SelectRole('contributor')
            }
        })
        this.DocumentsMenu[0].items.forEach((menu: any) => {
            if (window.location.href.includes(menu.routerLink[0])) {
                this.SelectRole('Documents')
            }
        })
        this.AdminMenu[0].items.forEach((menu: any) => {
            if (window.location.href.includes(menu.routerLink[0])) {
                this.SelectRole('admin')
            }
        })
        if (this.AiAgentDashboardMenu && this.AiAgentDashboardMenu.length > 0 && this.AiAgentDashboardMenu[0].items) {
            this.AiAgentDashboardMenu[0].items.forEach((menu: any) => {
                if (menu.routerLink && window.location.href.includes(menu.routerLink[0])) {
                    this.SelectRole('AIDashboard')
                }
            })
        }
        if (this.PlinyMenu && this.PlinyMenu[0].items) {
            this.PlinyMenu[0].items.forEach((menu: any) => {
                // Check nested items (Providers, Locations, Patient sub-menus)
                if (menu.items) {
                    menu.items.forEach((subMenu: any) => {
                        if (subMenu.routerLink && window.location.href.includes(subMenu.routerLink[0])) {
                            this.SelectRole('pliny')
                        }
                    })
                }
                // Check direct items
                if (menu.routerLink && window.location.href.includes(menu.routerLink[0])) {
                    this.SelectRole('pliny')
                }
            })
            // Also check if URL contains /pliny
            if (window.location.href.includes('/pliny')) {
                this.SelectRole('pliny')
            }
        }
    }


    // findData(item: any) {
    //     const dataToDisplay = this.getDataForItem(item)
    //     this.allFunctionListDeail = dataToDisplay
    //     this.service.filterData(this.allFunctionListDeail)
    // }
    // getDataForItem(item: any) {
    //     return this.allFunctionList.find(
    //         (dataItem) => dataItem.name === item.name
    //     )
    // }
}
